import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RouteErrorBoundaryCore } from "./ErrorBoundaryCore";

export const RouteErrorBoundary = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const resetKey = `${location.pathname}${location.search}${location.hash}`;

  return (
    <RouteErrorBoundaryCore
      resetKey={resetKey}
      onHome={() => navigate("/")}
    >
      {children}
    </RouteErrorBoundaryCore>
  );
};
